import React, { Component } from 'react';
import { connect } from 'react-redux';
import { distillProductType, getMainUnitFromBundleMembers } from 'common/utils/helpers';
import { isItBundle } from 'common/utils/deviceTwinUtils';
import { deviceDisplayTypes, DEVICES_PAGE_TAB } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import { Link } from 'react-router-dom';

/* By using a custom row component, the logic for tracking the selected row can be moved out of the table component. This allows us to change which row is highlighted
   without rerendering the entire table, which in turn keeps the scroll bar from resetting its position */
export default class DeviceTableRow extends Component {
  render() {
    let className = 'rt-tr';

    var deviceDetails;
    var deviceType;
    var bundle;
    var mainDevice;
    var isBundle = false;
    var selectedId;
    try {
      let original =
        this.props.children[0].props.children.props && this.props.children[0].props.children.props.original;

      isBundle = original && isItBundle(original);
      bundle = isBundle ? original : null;
      mainDevice = isBundle ? getMainUnitFromBundleMembers(original?.members) : original;

      if (mainDevice == null) {
        mainDevice = original?.members.find((d) => d?.properties?.reported?.location != null);
      }

      if (mainDevice == null) {
        mainDevice = original?.members?.[0];
      }

      selectedId = isBundle && original ? original.bundleId : original && original.deviceId;

      if (mainDevice && this.props.selectedDeviceId === selectedId) {
        deviceDetails = mainDevice;
        deviceType = distillProductType(mainDevice.properties?.reported?.productType);
        if (deviceType === 'donor' || isBundle)
          className += `${
            this.props.forAlarmMap ? ' DeviceTableRow_SelectedPivot_ForAlarm' : ' DeviceTableRow_SelectedPivot'
          }`;
        else className += ' DeviceTableRow_Selected';
      }
    } catch (error) {
      console.error(error);
    }

    let linkedServiceDevices = [];

    if (bundle && bundle.members && bundle.members.length > 0) {
      linkedServiceDevices = bundle.members.filter((member) => member.deviceId !== mainDevice.deviceId);
    }

    let donorDisplayString =
      this.props.displayType === deviceDisplayTypes.NAME && deviceDetails?.tags?.userLabel
        ? deviceDetails.tags.userLabel
        : deviceDetails?.deviceId;

    return (
      <div id={className} className={className}>
        {this.props.children}
        {this.props.forAlarmMap && (
          <div
            id="DeviceTableRow_Selected_PivotDetailsSection_Break"
            className="DeviceTableRow_Selected_PivotDetailsSection_Break"
          ></div>
        )}
        {isBundle && deviceDetails && this.props.expandedBundleId === selectedId && (
          <div id="DeviceTableRow_Selected_PivotDetailsSection" className="DeviceTableRow_Selected_PivotDetailsSection">
            <div
              id="DeviceTableRow_Selected_PivotDetailsContent"
              className="DeviceTableRow_Selected_PivotDetailsContent"
            >
              <div
                id="DeviceTableRow_Selected_LinkedDevicePill"
                className="DeviceTableRow_Selected_LinkedDevicePill"
                data-tip={donorDisplayString}
              >
                <img alt="IconLoader.icon_donor" src={IconLoader.icon_donor} draggable="false" />
                <Link
                  to={`/console/devices/${
                    this.props.activeTab === DEVICES_PAGE_TAB.all
                      ? `detail?${deviceDetails.id.toString()}`
                      : `pivot/overview?deviceId=${deviceDetails.id.toString()}&detail=${deviceDetails?.deviceId}`
                  }`}
                >
                  {donorDisplayString}
                </Link>
              </div>
              {linkedServiceDevices &&
                linkedServiceDevices.map((device, idx) => {
                  const serviceDisplayString =
                    this.props.displayType === deviceDisplayTypes.NAME && device?.tags?.userLabel
                      ? device.tags.userLabel
                      : device?.deviceId;
                  return (
                    <div
                      id="DeviceTableRow_Selected_LinkedDevicePill"
                      className="DeviceTableRow_Selected_LinkedDevicePill"
                      key={idx}
                      data-tip={serviceDisplayString}
                    >
                      <img alt="" src={IconLoader.icon_service} />
                      <Link
                        to={`/console/devices/${
                          this.props.activeTab === DEVICES_PAGE_TAB.all
                            ? `detail?${device.id}`
                            : this.props.activeTab === DEVICES_PAGE_TAB.echo
                            ? `echo/overview?deviceId=${deviceDetails.id.toString()}&detail=${device?.deviceId}`
                            : `pivot/overview?deviceId=${deviceDetails.id.toString()}&detail=${device?.deviceId}`
                        }`}
                      >
                        {serviceDisplayString}
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

DeviceTableRow = connect((store) => {
  let activeTab = store.ui.devicesPage.activeTab;
  let displayType;
  if (activeTab === DEVICES_PAGE_TAB.pivot) {
    displayType = store.ui.devicesPage.pivotTab.deviceDisplayMode;
  } else if (activeTab === DEVICES_PAGE_TAB.echo) {
    displayType = store.ui.devicesPage.echoTab.deviceDisplayMode;
  } else {
    displayType = store.ui.devicesPage.allDevicesTab.deviceDisplayMode;
  }
  return {
    activeTab,
    displayType,
    selectedDeviceId: store.ui.devicesPage.selectedDeviceId,
    expandedBundleId: store.ui.devicesPage.expandedBundleId,
    bulkViewModalOpen: store.ui.devicesPage.bulkViewModalOpen
  };
})(DeviceTableRow);
